import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from "../../../app/config";
import {TChooseType, TFieldType, TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {
    TAction,
    TBrandedQuem,
    TBrandedTipo,
    TProdutoTipo,
    THotspotFlag,
    TProfileTeam,
    TProfileSexo,
    TUpperLowerCase,
} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {WebstorService} from "../../../providers/webstor-service";
import {ModalFieldPage} from "../modal-field/modal-field";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {BrandedHtmlPage} from "../branded-html/branded-html";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {BlendedMenuPage} from "../blended-menu/blended-menu";
import {HotspotMenuPage} from "../hotspot-menu/hotspot-menu";
import {HotspotService} from "../../../providers/hotspot-service";
import {WebstorOpenPage} from "../webstor-open/webstor-open";

@Component({
    selector: 'page-branded-menu',
    templateUrl: 'branded-menu.html',
    providers: [WebstorService, HotspotService, ProfileService, ProfileRepository]
})
export class BrandedMenuPage {

    TFieldType: any = TFieldType;
    TChooseType: any = TChooseType;
    TBrandedQuem: any = TBrandedQuem;
    TBrandedTipo: any = TBrandedTipo;

    config: any;
    logado: any;

    etapa: number;
    rootile: any;
    brandeds: any;
    negocios: Array<any>;
    logoerro: Array<boolean> = [false, false, false, false];

    brandClass: any = {
        BrandedID: 0,
        BrandedNome: '',
        BrandedShow: '',
        BrandedNick: '',
        BrandedSame: '',
        BrandedBank: '',
        BrandedCard: false,
        BrandedGate: false,
        BrandedSexo: TProfileSexo.psNenhum,
        BrandedQuem: TBrandedQuem.whNone,
        BrandedTipo: TBrandedTipo.btMarca,
        BrandedSoma: true,
        BrandedPage: false,
        BrandedCora: '',
        BrandedInfo: '',
        BrandedAppb: '',
        BrandedClid: '',
        BrandedScrt: '',
        BrandedBody: {Brand: null, Hspot: null},

        BrandedBase: '',
        BrandedIcon: '',
        BrandedLogo: '',
        BrandedSymb: '',

        Brended: this.navParams.get('brended'),
        HotspotID: this.util.anyParams(0, this.navParams.get('hotspotID')),

        MeritumQtde: 0,
        BlendedQtde: 0,
        HotspotQtde: 0,

        Negocio: {
            NegocioID: 0,
            NegocioNome: '',
            NegocioName: '',
            NegocioIcon: 'b-icon-home'
        },
    };

    constructor(public navCtrl: NavController, public navParams: NavParams, public util: Util,
                public viewCtrl: ViewController,
                public hotspotService: HotspotService, public profileRepository: ProfileRepository,
                public logadoService: LogadoService, public webstorService: WebstorService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();

        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.brandeds = this.navParams.get('brandeds');
        this.negocios = this.navParams.get('negocios');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Marketing', '/hotspot-mark');

        this.brandedLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent, false);

    }

    brandedLoad() {

        //brandedCria
        if (!this.brandeds) {
            this.brandeds = [this.brandClass];
            return;
        }

        let brandedID = (this.etapa == 0 ? 0 : this.brandeds[0].BrandedID);
        if (this.etapa == 1 && !brandedID) return;

        let loading = this.util.loadingDots();
        loading.present();

        if (this.etapa == 1) {

            this.webstorService.negocio(TAction.acList, this.brandeds[0].BrandedID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => this.brandeds[0].Negocios = data.Negocios,
                    erro => this.util.alertResult(erro, () => this.dismiss())
                )

        }

    }

    getTitle() {

        if (this.etapa == 0) return 'Marcas';
        if (this.etapa == 1) return (!this.brandeds[0].BrandedID ? TBrandedTipo[this.brandeds[0].BrandedTipo].slice(2, 99) : this.brandeds[0].BrandedNome);

    }

    getIcone() {

        if (this.brandeds[0].BrandedSexo == TProfileSexo.psFeminino)  return 'b-icon-female';
        if (this.brandeds[0].BrandedSexo == TProfileSexo.psMasculino) return 'b-icon-male';
        return 'b-icon-search';

    }

    logoerror(pos: number, event?) {

        this.logoerro[pos] = true;
        event.parentElement.removeChild(event);

    }

    logocheck(pos: number, keyname: string, invert: boolean): boolean {

        if (!invert) return (this.brandeds[0][keyname] && !this.logoerro[pos]);
        if (invert)  return (!this.brandeds[0][keyname] || this.logoerro[pos]);

    }

    brandedMenu(branded) {

        let onCria = (brandnew) => {
            if (branded || !brandnew) return;

            let negocio = this.brandeds[0].Negocios.find(ng => ng.NegocioID == brandnew.Negocio.NegocioID);
            if (!negocio) {
                negocio = this.util.deepCopy(brandnew.Negocio);
                negocio.Brandeds = [];
                this.brandeds[0].Negocios.push(negocio);
            }
            negocio.Brandeds.push(brandnew);
        };

        let array = (branded ? [branded] : null);
        let object = {etapa: 1, rootile: this.rootile, brandeds: array, brended: this.brandeds[0], negocios: this.negocios};
        if (branded)  this.navCtrl.push(BrandedMenuPage, object);
        if (!branded) this.util.modalopen(BrandedMenuPage, 'full', false, object).subscribe(data => onCria(data));

    }

    brandedSave(that, send?) {

        //Criando novo registro...
        if (!this.brandeds[0].BrandedID && !send) {
            if (that) that.dismiss();
            return;
        }


        //Criando ou Editando...
        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.branded(TAction.acSave, this.brandeds[0].BrandedID, this.brandeds[0].HotspotID, this.logado.Profile.ProfileID, this.brandeds[0])
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (!this.brandeds[0].BrandedID) {
                        this.brandeds[0].BrandedID = data.Codigo;

                        let negocio = this.negocios.find(nx => (nx.NegocioID == this.brandeds[0].Negocio.NegocioID));
                        if (!negocio) {
                            negocio = this.util.deepCopy(this.brandeds[0].Negocio);
                            negocio.Brandeds = [];
                            this.negocios.unshift(negocio);
                        }

                        negocio.Brandeds.unshift(this.brandeds[0]);
                    }

                    if (that) that.dismiss(this.brandeds[0]);
                    if (!this.brandeds[0].BrandedID) this.brandedLoad();

                },
                erro => this.util.alertResult(erro)
            );

    }

    brandedLixo() {

        let onConfir = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.branded(TAction.acLixo, this.brandeds[0].BrandedID, this.brandeds[0].HotspotID, this.logado.Profile.ProfileID, this.brandeds[0])
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        if (this.negocios) {
                            this.negocios.forEach(nx => {
                                let index = nx.Brandeds.findIndex(br => br.BrandedID == this.brandeds[0].BrandedID);
                                nx.Brandeds.splice(index, 1);
                            });
                        }

                        this.brandeds = null;
                        this.dismiss();

                    },
                    erro => this.util.alertResult(erro)
                );

        };

        let alerta = 'Esse processo não tem volta.';
        this.util.alertQuestion('Deseja excluir?', alerta, 'Continuar', () => onConfir(), false, true);

    }

    brandedBody() {

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Brand', handler: () => this.brandedHtml('Brand')});
        buttons.push({text: 'Hspot', handler: () => this.brandedHtml('Hspot')});
        this.util.sheetOpen(buttons, 'KEYPLATE');

    }

    brandedHtml(keyplate: 'Brand' | 'Hspot') {

        let copybran = this.util.deepCopy(this.brandeds[0]);
        let object = {rootile: this.rootile, rootbran: this.brandeds[0], copybran: copybran, keyplate: keyplate};
        this.navCtrl.push(BrandedHtmlPage, object);

    }

    brandedComb() {

        let show = !!this.brandeds[0].BrandedNome;

        /** OPEN **/
        let buttons: Array<any> = [];
                  buttons.push({text: 'Edit', handler: () => this.brandedSexo()});
        if (show) buttons.push({text: 'Tipo', handler: () => this.brandedTipo()});
        this.util.sheetOpen(buttons, 'SETTING');

    }

    brandedSexo() {

        let onSave = (sexo) => {
            this.brandeds[0].BrandedSexo = sexo;
            this.brandedText('BrandedNome', TFieldType.ftLine);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TProfileSexo, TProfileSexo.psMasculino);
        let buttons: Array<any> = [];
        arrayEnum.forEach(sexo => buttons.push({text: sexo.slice(2, 99), handler: () => onSave(TProfileSexo[sexo])}));
        this.util.sheetOpen(buttons, 'SEXO');

    }

    brandedTipo() {

        let onSave = (tipo) => {
            this.brandeds[0].BrandedTipo = tipo;
            this.brandedSave(null);
        };

        /** OPEN **/
        let arrayEnum = this.util.enumArray(TBrandedTipo, TBrandedTipo.btMarca);
        let buttons: Array<any> = [];
        arrayEnum.forEach(tipo => buttons.push({text: tipo.slice(2, 99), handler: () => onSave(TBrandedTipo[tipo])}));
        this.util.sheetOpen(buttons, 'TIPO');

    }

    brandedNick() {

        this.brandedText('BrandedNick', TFieldType.ftLine, {trim: true, sensity: TUpperLowerCase.ulLower});

    }

    brandedSame() {

        this.brandedText('BrandedSame', TFieldType.ftLine, {trim: true, sensity: TUpperLowerCase.ulNormal});

    }

    brandedText(fieldName, fieldType: TFieldType, options: any = null) {

        let onOkiy = (that, okiy, index, isLast) => {

            this.brandeds[0][fieldName] = okiy[0].groups[0].fields[0].value;
            this.brandedSave(that);

        };

        /** SLIDE 01 **/
        let fieldNome = this.config.modalField(fieldType, 'Nome', null, null, this.brandeds[0][fieldName], null, options);
        let groupNome = this.config.modalGroup(null, [fieldNome]);
        let slideNome = this.config.modalSlide('Info', null, null, null, 'CorRoxa', [groupNome]);

        this.util.modalopen(ModalFieldPage, 'alto', false, {slides: [slideNome], onOkiy: onOkiy}).subscribe();

    }

    brandedCorx() {

        let onOkiy = (that, okiy, index, isLast) => {

            //if (this.util.slideNext(that, (index == 0))) return;

            this.brandeds[0].BrandedCora = okiy[0].groups[0].fields[0].value;
            this.brandedSave(that);

        };


        let colorList: any[] = [];
        for (let color in this.config.colors) colorList.push({title: color, value: color});

        /** SLIDE 01 **/
        let fieldCora = this.config.modalField(TFieldType.ftColor, null, null, null, this.brandeds[0].BrandedCora, colorList, null);
        let groupCora = this.config.modalGroup(null, [fieldCora]);
        let slideCora = this.config.modalSlide('Pintura', 'Vamos pintar?', 'Selecione uma cor!', 'b-icon-brush', 'CorRoxa', [groupCora]);

        this.util.modalopen(ModalFieldPage, 'alto', false, {slides: [slideCora], onOkiy: onOkiy}).subscribe();

    }

    brandedLogo(field: any) {

        let logosize = (field == 'BrandedBase' || field == 'BrandedLogo' ? 1024 : 250);
        let logobyte = (field == 'BrandedBase' || field == 'BrandedLogo' ? (900 * 1024) : (200 * 1024));
        let options = {acceptTypes: 'image/png', sizebyte: logobyte, selectLimit: 0, minmax: 'FIX', width: logosize, height: logosize, quality: 100};
        this.util.fileSelect(options).subscribe(
            base => {

                this.util.pngTransparent(base[0].base64)
                    .subscribe(
                        data => {
                            let fie64 = field + '64';
                            this.brandeds[0][fie64] = base[0].base64.split(',')[1];
                            this.brandeds[0][field] = base[0].base64;
                            this.brandedSave(null);
                        },
                        erro => this.util.alertSimply('PNG não é transparente!')
                    );

            },

            erro => this.util.alertResult(erro)
        );

    }

    negocioMenu() {

        let onSave = (data) => {
            if (!data) return;
            this.brandeds[0].Negocio = data[0];
            this.brandedSave(null);
        };

        let object = {homeb: false, etapa: 0, title: null, keyname: 'Negocio', toggler: 'hide'};
        this.util.modalopen(WebstorOpenPage, 'wide', false, object).subscribe(data => onSave(data));

    }

    integraShow(copy?, event?) {

        if (copy) {
            let apiauthCopy = 'ClientID: ' + this.brandeds[0].BrandedClid + '\n' + 
                              'SecretID: ' + this.brandeds[0].BrandedScrt;
            this.util.clipboardCopy(apiauthCopy);
            event.stopPropagation();
            return;
        }

        let have = this.brandeds[0].BrandedClid.length;
        if (have) {
            let apiauthCopy = 'ClientID: ' + this.util.plural(this.brandeds[0].BrandedClid.length, 'char') + '<br>' + 
                              'SecretID: ' + this.util.plural(this.brandeds[0].BrandedScrt.length, 'char');
            this.util.alertSimply(apiauthCopy, 'API-AUTH');
            return;
        }

        //Abre janela para cadastrar!, se quiser deixar editar coloca no alert botao para "deseja editar?"

    }

    blendeds() {

        let objectBle = {homeb: true, etapa: 0, branded: this.brandeds[0]};
        this.navCtrl.push(BlendedMenuPage, objectBle);

    }

    stations() {

    }

    meritums() {

        let onOpen = (meritum) => {
            meritum = {MeritumID: meritum.MeritumID};
            let object = {homeb: true, etapa: 1, rootile: this.logado, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone};
            this.navCtrl.push(MeritumMenuPage, object);
        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.meritum(TAction.acLoad, 0, this.brandeds[0].BrandedID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    /** OPEN **/
                    let buttons: Array<any> = [];
                    data.Meritums.forEach(mr => buttons.push({text: mr.MeritumNome, handler: () => onOpen(mr)}));
                    buttons.push({text: 'Adicionar', cssClass: this.util.sheetClass(), handler: () => onOpen(null)});
                    this.util.sheetOpen(buttons, 'MERITUM');

                },
                erro => this.util.alertResult(erro)
            );

    }

    hotspots() {

        let onOpen = () => {
            /** OPEN **/
            let buttons: Array<any> = [];
            this.brandeds[0].Unidades.forEach(unidade => {
                buttons.push({text: unidade.UnidadeNome || 'Acessar', handler: () => this.hotspotPush(unidade.HotspotID, unidade.HotspotFlag)});
            });
            if (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager) buttons.push({text: 'Adicionar', handler: () => this.hotspotCria()});
            this.util.sheetOpen(buttons, 'UNIDADE');
        };

        if (this.brandeds[0].Unidades) {
            onOpen();
            return;
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.unidade(TAction.acLoad, this.brandeds[0].BrandedID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.brandeds[0].Unidades = data.Unidades;
                    onOpen();
                },
                erro => this.util.alertResult(erro)
            );

    }

    hotspotPush(hotspotID, status) {

        let copybra = this.util.deepCopy(this.brandeds[0]);
        delete copybra.Negocios;
        delete copybra.Unidades;

        copybra.HotspotFlag = status;

        let object = {etapa: 0, rootile: this.rootile, hotspotID: hotspotID, branded: copybra};
        this.navCtrl.push(HotspotMenuPage, object);

    }

    hotspotCria() {

        if (!this.brandeds[0].BrandedNick) {
            this.util.alertSimply('Username não definido');
            return;
        }

        this.hotspotPush(0, THotspotFlag.hfHotspotAberto);

    }

    dismiss() {

        let branded = (this.brandeds[0] && this.brandeds[0].BrandedID ? this.brandeds[0] : null);

        if (this.viewCtrl.isOverlay) this.viewCtrl.dismiss(branded);
        else this.navCtrl.pop();

        this.util.statusBarColor(TStatusBar.sbBackupRestore);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/branded-menu/branded-menu.ts